module.exports = __webpack_public_path__ + "static/preview-tabs-style-environment-bda27fd052deabb60e75852717868af5.png";